import { FC } from 'react'
import { Pet } from '../models'
import { Avatar } from './Avatar'

export type PetChipProps = {
  className?: string
  active?: boolean
  readonly?: boolean
  onClick?: any
  pet: Pet
}

export const PetChip: FC<PetChipProps> = ({ pet, className = '', active = false, readonly = false, onClick }) => {
  const classes = active ? 'bg-primary-500 text-white' : 'bg-primary-200 text-black'
  return (
    <div
      className={`transition space-x-1 rounded-full p-0.5 px-1.5 border border-primary-400 inline-flex items-center ${classes} ${
        !readonly && 'cursor-pointer'
      } ${className}`}
      {...(onClick && !readonly ? { onClick } : null)}
    >
      <Avatar
        image={pet.ImageId ? `${process.env.REACT_APP_FILES_PATH}/${pet.ImageId}?width=50` : undefined}
        title={pet?.name?.slice(0, 1)}
        className="w-4 h-4 text-body-xxs"
      />
      <span className="text-body-small capitalize">{pet?.name}</span>
    </div>
  )
}
